import {
         NOTIFICACAO,
         STATUS_TALENTOS,
         STATUS_ACESSO_DIARIO,
         TESTE_NOTIFICACAO,
         TESTE_NOTIFICACAO2,
         STATUS_NOTIFICACAO,
         SET_ERROR_ACTION
        } from '../actions/notificacaoAction';

const INITIAL_STATE = { 
                       all_notificacao : [],
                       set_error : null
                      };

export default function(state = INITIAL_STATE,action){

switch (action.type) {

    case NOTIFICACAO:
       return { ...state, all_notificacao:action.payload.data}

    case STATUS_NOTIFICACAO:
        const filtro = state.all_notificacao.filter((elem) =>{
            if(elem.not_id === action.payload) {
               elem.not_exibir === 0;
            }
            
        }) 
        return { ...state, all_notificacao : filtro }

    case STATUS_TALENTOS:
       
          return{ ...state, 
                  all_notificacao : [action.payload,...state.all_notificacao]
                }

    case STATUS_ACESSO_DIARIO:
               
    return { ...state, 
                all_notificacao: [action.payload,...state.all_notificacao]
            }

    case SET_ERROR_ACTION:

    return { ...state, 
                  set_error : action.payload
            }

    case TESTE_NOTIFICACAO:
              console.log("Aqui!");  
    // return { ...state, 
    //             all_notificacao: [action.payload,...state.all_notificacao]
    //         }
    case TESTE_NOTIFICACAO2:
              console.log("Aqui2!");  
    // return { ...state, 
    //             all_notificacao: [action.payload,...state.all_notificacao]
    //         }

    default:
       return state;
}

}


// WEBPACK FOOTER //
// ./src/reducers/reducer_notificacao.js